export function isDropFree(drop) {
  if (!drop) return false;
  if (drop.isFree === true) return true;
  if (drop.accessType === "free") return true;
  return drop.price === 0 || drop.price === "0";
}

export function formatDropPrice(drop) {
  if (isDropFree(drop)) return "Free";
  const price = Number(drop?.price);
  if (!Number.isFinite(price) || price <= 0) return "Free";
  return `$${price.toFixed(2).replace(/\.00$/, "")}`;
}

export function dropUnlockCtaLabel(drop, { closed = false, unlocked = false } = {}) {
  if (closed) return null;
  if (unlocked) return "Watch Now";
  if (isDropFree(drop)) return "Watch Free";
  const price = Number(drop?.price);
  if (Number.isFinite(price) && price > 0) {
    return `Unlock · $${price.toFixed(2).replace(/\.00$/, "")}`;
  }
  return "Unlock";
}
